export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email Logs"])},
        "search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechercher par destinataire, sujet..."])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun email log"])},
        "column_to": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destinataire"])},
        "column_subject": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sujet"])},
        "column_status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])},
        "column_sent_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date d'envoi"])},
        "column_opened_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ouvert"])},
        "status_pending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En attente"])},
        "status_delivered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Délivré"])},
        "status_bounce": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rebond"])},
        "status_processed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Traité"])},
        "status_dropped": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rejeté"])},
        "status_deferred": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Différé"])},
        "not_opened": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email Logs"])},
        "search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search by recipient, subject..."])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No email logs"])},
        "column_to": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recipient"])},
        "column_subject": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subject"])},
        "column_status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
        "column_sent_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sent date"])},
        "column_opened_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opened"])},
        "status_pending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pending"])},
        "status_delivered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delivered"])},
        "status_bounce": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bounced"])},
        "status_processed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Processed"])},
        "status_dropped": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dropped"])},
        "status_deferred": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deferred"])},
        "not_opened": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No"])}
      }
    }
  })
}
